var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconBnpl48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2247_8990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0111 43.1203C34.2873 43.1203 42.6178 34.7898 42.6178 24.5136C42.6178 14.2373 34.2873 5.9068 24.0111 5.9068C13.7348 5.9068 5.4043 14.2373 5.4043 24.5136C5.4043 34.7898 13.7348 43.1203 24.0111 43.1203Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.999 43.1081C18.5733 42.8258 14.0938 40.9363 10.5606 37.4396C7.02745 33.943 5.30975 29.6302 5.40752 24.5013C6.12457 24.5013 7.55468 24.5013 9.69787 24.5013C9.6826 26.028 9.53231 29.841 13.6729 34.4631C16.9862 38.1762 21.6056 38.8142 23.999 38.8142C23.9888 39.7604 23.9888 41.1917 23.999 43.1081Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0103 43.1081C29.436 42.8258 33.9154 40.9363 37.4486 37.4396C40.9818 33.943 42.6995 29.6302 42.6018 24.5013C41.8847 24.5013 40.4546 24.5013 38.3114 24.5013C38.3267 26.028 38.477 29.841 34.3364 34.4631C31.0231 38.1762 26.4036 38.8142 24.0103 38.8142C24.0204 39.7604 24.0204 41.1917 24.0103 43.1081Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0103 5.89459C29.436 6.17691 33.9154 8.0664 37.4486 11.563C40.9818 15.0597 42.6995 19.3725 42.6018 24.5014C41.8847 24.5014 40.4546 24.5014 38.3114 24.5014C38.3267 22.9747 38.477 19.1616 34.3364 14.5396C31.0231 10.8265 26.4036 10.1885 24.0103 10.1885C24.0204 9.24232 24.0204 7.81103 24.0103 5.89459Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0111 43.1203C34.2873 43.1203 42.6178 34.7898 42.6178 24.5136C42.6178 14.2373 34.2873 5.9068 24.0111 5.9068C13.7348 5.9068 5.4043 14.2373 5.4043 24.5136C5.4043 34.7898 13.7348 43.1203 24.0111 43.1203Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9989 38.8143C31.9037 38.8143 38.3118 32.4062 38.3118 24.5014C38.3118 16.5966 31.9037 10.1885 23.9989 10.1885C16.0941 10.1885 9.68604 16.5966 9.68604 24.5014C9.68604 32.4062 16.0941 38.8143 23.9989 38.8143Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7242 20.6846H18.2739V32.1349H29.7242V20.6846Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.999 23.4117C27.4132 23.4117 27.749 23.0759 27.749 22.6617C27.749 22.2475 27.4132 21.9117 26.999 21.9117C26.5848 21.9117 26.249 22.2475 26.249 22.6617C26.249 23.0759 26.5848 23.4117 26.999 23.4117Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.999 23.4117C21.4132 23.4117 21.749 23.0759 21.749 22.6617C21.749 22.2475 21.4132 21.9117 20.999 21.9117C20.5848 21.9117 20.249 22.2475 20.249 22.6617C20.249 23.0759 20.5848 23.4117 20.999 23.4117Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8619 19.7304C26.8619 18.1494 25.5803 16.8678 23.9993 16.8678C22.4183 16.8678 21.1367 18.1494 21.1367 19.7304",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 38.8143V43.1081",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 5.89459V10.1885",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39209 24.5013H9.68596",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3115 24.5013H42.6054",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_8990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconBnpl48);
export default __webpack_public_path__ + "static/media/pictogramBeaconBNPL48.5d2535f3007ddd924ec02558b73b7c3c.svg";
export { ForwardRef as ReactComponent };